import React, { useEffect, useState } from 'react';
import { Tooltip } from '@ohif/ui';
import classnames from 'classnames';
import { useToolbar } from '@ohif/core';
import Icon from '../../../../platform/ui/src/components/Icon';

export function Toolbar({
  servicesManager,
  buttonSection = 'primary',
  updateSeriesOpen,
  seriesOpen,
}) {
  const { toolbarButtons, onInteraction } = useToolbar({
    servicesManager,
    buttonSection,
  });

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      // Detectar mobile usando el userAgent
      const isMobileDevice = /(Mobi|Android|iPhone|iPad|iPod)/.test(navigator.userAgent);
      setIsMobile(isMobileDevice);
    };

    // Llamar una vez al montar el componente
    handleResize();

    // Suscribirnos al evento resize
    window.addEventListener('resize', handleResize);

    // Desuscribirnos al desmontar
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!toolbarButtons.length) {
    return null;
  }

  const ImageButton = ({ iconName, onClick }) => (
    <div
      className={classnames('flex cursor-pointer items-center')}
      style={{
        color: '#ffffff',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '1px 1px',
        marginRight: '0px',
        marginTop: '-4px',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
      }}
      onClick={onClick}
    >
      <Icon
        name={iconName}
        style={{ width: '30px', height: '30px', zIndex: 301 }}
      />
    </div>
  );

  // Iconos de abrir/cerrar panel
  const getCloseIcon = () => (
    <ImageButton
      iconName="ver2"
      onClick={() => updateSeriesOpen(false)}
    />
  );

  const getOpenIcon = () => (
    <ImageButton
      iconName="ver1"
      onClick={() => updateSeriesOpen(true)}
    />
  );

  return (
    <>
      {isMobile ? (
        <div
          style={{
            marginRight: '-1%',
            marginTop: '-35px',
            position: 'absolute',
          }}
        >
          {seriesOpen ? getCloseIcon() : getOpenIcon()}
        </div>
      ) : (
        ''
      )}
      {!isMobile && (seriesOpen ? getCloseIcon() : getOpenIcon())}
      {toolbarButtons.map(toolDef => {
        if (!toolDef) {
          return null;
        }
        const { id, Component, componentProps } = toolDef;
        return (
          <div key={id}>
            <Component
              id={id}
              onInteraction={onInteraction}
              servicesManager={servicesManager}
              {...componentProps}
            />
          </div>
        );
      })}
    </>
  );
}
